<template>
	<footer class="footer">
		<div class="container">
			<div class="content has-text-centered">
				<p>Copyright &copy; Tomb Raider Marathon 2017 {{ getCopyrightDate }}</p>
				<p>We are in no way associated with Square Enix or Crystal Dynamics, we're a non-profit fan-based charity gaming marathon that aims to have fun whilst raising money for charity.</p>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'footerview',
	computed: {
		getCopyrightDate () {
			var date = new Date();
			var year = date.getFullYear();
			if (year > 2017)
				return ` - ${year}`;

			return ``;
		}
	}
}
</script>

<style scoped lang="scss">
.footer {
	border-top: 1px solid $default-border-col;
}
.content {
	padding: 15px;
}

p {
	font-size: 1rem;
	margin: 0;

	&:not(:last-child) {
		color: $marathon-col;
		font-weight: bold;
		margin-bottom: 5px;
	}
}
</style>


// WEBPACK FOOTER //
// FooterView.vue?4cf19758